import { render, staticRenderFns } from "./TipoLugarInteresModalNuevo.vue?vue&type=template&id=076a7ea6&scoped=true&"
import script from "./TipoLugarInteresModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./TipoLugarInteresModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./TipoLugarInteresModalNuevo.vue?vue&type=style&index=0&id=076a7ea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a7ea6",
  null
  
)

export default component.exports